import { FC, useMemo } from 'react'

import useFollowUpAlert from '@hook/alerts/use-followup'
import useTable from '@hook/shared/use-table'

import TableGridCollpseFollowUp from './item-collapse'

const TableGridBodyFollowUp: FC = () => {
  const { data: rows } = useTable()
  const { data } = useFollowUpAlert()

  const group = useMemo(() => {
    let purchases: any[] = []
    const rowsDistinct = data
      .map(item => item['general-pedido'])
      .filter((value, index, self) => self.indexOf(value) === index)
    for (const rows of rowsDistinct) {
      purchases = [
        ...purchases,
        data.filter((x: any) => x['general-pedido'] === rows)
      ]
    }
    return rowsDistinct
  }, [data])
  return (
    <tbody>
      {rows.data.length === 0 ? (
        <tr>
          <td colSpan={12} align="center">
            Dados não encontrados
          </td>
        </tr>
      ) : (
        group.map(value => (
          <>
            <TableGridCollpseFollowUp filterDate={value} />
          </>
        ))
      )}
    </tbody>
  )
}
export default TableGridBodyFollowUp
